import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SpineLabel"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M2.25027 8.25V9.75H6.44277L1.71777 14.4675L2.78277 15.5325L7.50027 10.8075V15H9.00027V8.25H2.25027ZM19.5003 9.75H17.2503V9H15.7503V9.75H13.5003C12.6719 9.75 12.0003 10.4216 12.0003 11.25V12.75C12.0003 13.5784 12.6719 14.25 13.5003 14.25H15.7503V15H17.2503V14.25H19.5003C20.3287 14.25 21.0003 13.5784 21.0003 12.75V11.25C21.0003 10.4216 20.3287 9.75 19.5003 9.75ZM13.5003 12.75V11.25H19.5003V12.75H13.5003ZM19.5003 17.25H17.2503V16.5H15.7503V17.25H13.5003C12.6719 17.25 12.0003 17.9216 12.0003 18.75V20.25C12.0003 21.0784 12.6719 21.75 13.5003 21.75H15.7503V22.5H17.2503V21.75H19.5003C20.3287 21.75 21.0003 21.0784 21.0003 20.25V18.75C21.0003 17.9216 20.3287 17.25 19.5003 17.25ZM13.5003 20.25V18.75H19.5003V20.25H13.5003ZM19.5003 2.25H17.2503V1.5H15.7503V2.25H13.5003C12.6719 2.25 12.0003 2.92157 12.0003 3.75V5.25C12.0003 6.07843 12.6719 6.75 13.5003 6.75H15.7503V7.5H17.2503V6.75H19.5003C20.3287 6.75 21.0003 6.07843 21.0003 5.25V3.75C21.0003 2.92157 20.3287 2.25 19.5003 2.25ZM13.5003 5.25V3.75H19.5003V5.25H13.5003Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SpineLabel.vue"]]);
